/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ComponentLike, ContentValue } from '@glint/template';

interface BvChoiceSignature {
  Args: {
    disabled?: boolean;
    error?: string;
    helpText?: ContentValue;
    id?: string;
    label?: ContentValue | ComponentLike;
    labelClass?: string;
    labelHidden?: boolean;
    onClick?: () => void;
    onMouseOut?: () => void;
    onMouseOver?: () => void;
  };
  Blocks: {
    default: [{ helpTextId?: string; errorId?: string }];
  };
  Element: HTMLElement;
}

const BvChoiceComponent = templateOnlyComponent<BvChoiceSignature>();

export default BvChoiceComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvChoice: typeof BvChoiceComponent;
    'bv-choice': typeof BvChoiceComponent;
  }
}
